import React, { useContext, useEffect, useState } from 'react'
import { GoogleMap, Marker } from '@react-google-maps/api';
import { DataContext } from "../../../js/App";
import './maps.scss'
import { Button, Modal } from 'react-bootstrap';
import usePlacesService from "react-google-autocomplete/lib/usePlacesAutocompleteService";
import {GOOGLE_MAP_API} from '../../../config';
import Geocode from './Geocode';
import { getUUID } from '../../../utils/helpers';


const Maps = ({ fieldLabel, defaultPosition, startOpen, name }) => {
    const context = useContext(DataContext);
    const [open, setOpen] = useState(startOpen ?? false);
    const [confirmed, setConfirmed] = useState(false);
    const [obtained, setObtained] = useState(false);
    const [markerLocation, setMarker] = useState({ lat: 0, lng: 0 });
    const [locationString, setLocationString] = useState("");
    const [autocompletePlace, setAutocompletePlace] = useState(null);
    const [showPrediction, setShowPrediction] = useState(false);

    const { handleUpdateValue, handleMultipleValues } = context;
    const [map, setMap] = useState(null);

    const geocodeClass = new Geocode();

    const setMarkerLocation = latLng => {
        setMarker({ lat: latLng.lat(), lng: latLng.lng() });
        handleUpdateValue(name, {lat: latLng.lat(), lng: latLng.lng(), confirmed});
    }

    let defaultProps = defaultPosition ?? {
        center: { lat: 51.500992, lng: -0.113955 },
        zoom: 12    };
    const mapOptions = {
        panControl: false,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        overviewMapControl: false,
        rotateControl: false
    };

    const containerStyle = {
        width: '100%',
        height: '400px',
        maxWidth: '100%'
    };

    const onLoad = React.useCallback(function callback(map) {
        const center = markerLocation.lat !== 0 && markerLocation.lng !== 0 ? markerLocation : defaultProps.center;
        map.setCenter(center)
        map.setZoom(14);

        setMap(map)
    }, [])

    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, [])

    const getDevicePosition = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    defaultProps.center.lat = position.coords.latitude;
                    defaultProps.center.lng = position.coords.longitude;
                    setMarker({ lat: position.coords.latitude, lng: position.coords.longitude });
                    if(map){
                        map.setZoom(17);
                    } else {
                        setTimeout(() => {
                            if(map){
                                map.setZoom(17);
                            }
                        }, 3000);
                    }
                    setObtained(true);                    
                },
                () => {
                    console.log("error")
                },
                {
                    enableHighAccuracy: true
                }
            );
        }
    };

    const openMapEvent = () => {
        if (!obtained) {
            getDevicePosition();
            setObtained(true);
        } else if(map !== null) {
            map.setCenter(markerLocation)
        }
        
        setOpen(!open);
    }

    //load map api with autocompleter
    const {
        placesService,
        placePredictions,
        getPlacePredictions,
        isPlacePredictionsLoading,
    } = usePlacesService({
        apiKey: GOOGLE_MAP_API,
        debounce: 300
    });


    const setLocation = place => {
        setLocationString(place.description);
        setShowPrediction(false);
        placesService?.getDetails(
            {
                placeId: place.place_id,
            },
            (placeDetails) => setAutocompletePlace({lat: placeDetails.geometry.location.lat(), lng : placeDetails.geometry.location.lng()})
        );
    }

    const confirmAddress = ()=>{
        setConfirmed(true);
        setOpen(false);
        handleUpdateValue(name, {lat: markerLocation.lat, lng: markerLocation.lng, confirmed: true});
    }

    useEffect(()=>{
        if(autocompletePlace !== null && autocompletePlace.lat !== markerLocation.lat && autocompletePlace.lng !== markerLocation.lng){
            setMarker(autocompletePlace);
        }
    }, [autocompletePlace])

    useEffect(()=>{
        if(markerLocation !== null && markerLocation.lat !== 0 && markerLocation.lng !== 0){
            geocodeClass.geoCodeMarkerPosition(markerLocation.lat, markerLocation.lng).then(data => {
                setFullAddress(data);
                handleUpdateValue(name, {lat: markerLocation.lat, lng: markerLocation.lng, confirmed});
            });
        }
    }, [markerLocation])

    const setFullAddress = address => {
        let value = null;
        const geocodeInputFields = ['geocode_postcode', 'geocode_address_line_2', 'geocode_address_line_1', 'geocode_location_details'];
        const valueToUpdate = []
        geocodeInputFields.forEach(geoField => {
            switch (geoField) {
                case 'geocode_address_line_1':
                    value = address.streetNumber + ' ' + address.address;
                    valueToUpdate[geoField] = value;
                    break;
                case 'geocode_address_line_2':
                    value = address.city;
                    valueToUpdate[geoField] = value;
                    break;
                case 'geocode_postcode':
                    value = address.postalCode;
                    valueToUpdate[geoField] = value;
                    break;
                default:
                    break;
            }
        });
        handleMultipleValues(valueToUpdate);
    };

    return (
        <>
            <div className="mapsContainer">
                <h2>{fieldLabel}</h2>
                <Button onClick={() => openMapEvent()}>View Map</Button>
            </div>
            <Modal show={open}>
                <Modal.Header closeButton onHide={() => setOpen(false)}>
                    <Modal.Title>{fieldLabel}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <GoogleMap
                        defaultZoom={markerLocation.lat !== 0 && markerLocation.lng !== 0 ? 14 : defaultProps.zoom}
                        onClick={evt => !confirmed ? setMarkerLocation(evt.latLng) : () => { console.log(confirmed) }}
                        center={markerLocation.lat !== 0 && markerLocation.lng !== 0 ? markerLocation : defaultProps.center}
                        mapTypeId={'roadmap'}
                        options={mapOptions}
                        onLoad={onLoad}
                        onUnmount={onUnmount}
                        mapContainerStyle={containerStyle}
                    >
                        <Marker onDragEnd={evt => setMarkerLocation(evt.latLng)} draggable={!confirmed ? true : false} position={markerLocation.lat !== 0 && markerLocation.lng !== 0 ? markerLocation : null} />
                        
                        <input
                            className='autocomplete-container'
                            type='text'
                            placeholder="Search a location"
                            value={locationString}
                            onChange={(evt) => {
                                setShowPrediction(true);
                                getPlacePredictions({ input: evt.target.value });
                                setLocationString(evt.target.value);
                            }}                            
                        />
                        <div
                            className='prediction-container'
                        >
                            {!isPlacePredictionsLoading && showPrediction && placePredictions && placePredictions.length > 0 && (<ul className='predictionPlaces'>
                                {placePredictions.map(place => {
                                    return <li key={`${name}_place_${getUUID()}`} onClick={() => setLocation(place)}>{place.description}</li>
                                })}
                            </ul>)}
                        </div>

                    </GoogleMap>
                    <div className='localize-icon' onClick={() => getDevicePosition()}></div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='modal-text'>
                        <p>
                            Please check that the marker on the map is at the correct location. If it is not, click on the map to reposition it.
                            <br />
                            <br />
                            Please press Confirm when all changes have been made.</p>
                    </div>
                    <Button onClick={() => setOpen(false)} variant="outline-danger">Close</Button>
                    <Button disabled={confirmed} onClick={() => confirmAddress()} variant="primary">{confirmed ? "Confirmed" : "Confirm"}</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}


export default Maps;